import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import convert from 'convert-length'
import vuetify from './plugins/vuetify'
import firebase from './plugins/firebase'
import localTemplates from './plugins/localTemplates'
import browserDetect from 'vue-browser-detect-plugin'
import crisp from './plugins/crisp'

Vue.config.productionTip = false
Vue.mixin({ methods: { mmToPx: (value) => convert(value, 'mm', 'px'), pxToMm: (value) => convert(value, 'px', 'mm') } })
Vue.use(browserDetect)
Vue.use(crisp, { router })

new Vue({
  router,
  store,
  vuetify,
  firebase,
  localTemplates,
  render: h => h(App)
}).$mount('#app')
